export const SignalRMethods = {
    SCORECARD_UPDATED: 'ScorecardUpdated',
    SCORECARD_CREATED: 'ScorecardCreated',
    SCORECARD_MARKED_OFFICIAL: 'ScorecardMarkedOfficial',
    SCORECARD_MARKED_NOT_OFFICIAL: 'ScorecardMarkedNotOfficial',
    TOURNAMENT_MARKED_ACTIVE: 'TournamentMarkedActive',
    TOURNAMENT_MARKED_NOT_ACTIVE: 'TournamentMarkedNotActive',
    ROUND_MARKED_ACTIVE: 'RoundMarkedActive',
    ROUND_MARKED_NOT_ACTIVE: 'RoundMarkedNotActive',
    ROUND_MARKED_OFFICIAL: 'RoundMarkedOfficial',
    ROUND_MARKED_NOT_OFFICIAL: 'RoundMarkedNotOfficial',
} as const;

export type SignalRMethodType = typeof SignalRMethods[keyof typeof SignalRMethods];
